// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3MYNp","header":"MergedInvoice_header__21kSN"};